import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toastface } from "../../interface/interface";
import { RootState } from "../../reducers";
import { ToastChange } from "../../reducers/config";
import "./css/index.css";
function Toast() {
  const dispatch = useDispatch();
  const { active, content } = useSelector<RootState, Toastface>(
    (state) => state.config.toast
  );
  useEffect(() => {
    if (active) {
      setTimeout(() => {
        dispatch(ToastChange({ active: false, content }));
      }, 1500);
    }

    return () => {};
  }, [active, dispatch, content]);

  return <div className={`toast ${active ? "toast-on" : ""}`}>{content}</div>;
}

export default Toast;
